export const SERVICES = [
  {
    slug: "limpieza-muebles",
    name: "Limpieza de Muebles",
    shortName: "Muebles",
    tagline: "Sofás y tapizados como nuevos, sin manchas ni malos olores",
    description:
      "Devolvemos la vida a tus sofás, sillas y tapizados con limpieza profunda por inyección-succión. Eliminamos manchas, ácaros, olores y toda la suciedad acumulada en las fibras, directamente en tu casa u oficina en Medellín.",
    image:
      "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&q=85",
    galleryImage:
      "https://images.pexels.com/photos/4401535/pexels-photo-4401535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    includes: [
      "Lavado profundo por inyección-succión",
      "Eliminación de manchas de comida, bebidas y mascotas",
      "Desinfección anti-ácaros y antibacteriana",
      "Neutralización de olores (humedad, mascotas, cigarrillo)",
      "Insumos biodegradables seguros para niños y mascotas",
      "Secado acelerado: listo en 4 a 6 horas",
    ],
    benefits: [
      "Recupera el color y la suavidad original de la tela",
      "Ambiente más sano para alérgicos y asmáticos",
      "Alargas la vida útil de tus muebles años",
    ],
    faqs: [
      {
        q: "¿Cuánto tarda en secarse el mueble?",
        a: "Con nuestro sistema de inyección-succión y secado acelerado, tu sofá queda listo para usar en 4 a 6 horas dependiendo de la ventilación del espacio.",
      },
      {
        q: "¿La limpieza daña la tela o el cuero?",
        a: "No. Evaluamos cada tipo de tapizado antes de empezar y usamos insumos específicos para cada material: tela, microfibra, cuero y cuero sintético.",
      },
      {
        q: "¿Atienden oficinas y empresas?",
        a: "Sí, limpiamos sillas de oficina, salas de espera y mobiliario corporativo con planes por volumen para empresas en Medellín.",
      },
      {
        q: "¿Qué pasa si una mancha no sale?",
        a: "Te lo decimos con honestidad antes de empezar. Si después del servicio no quedas satisfecho, nuestra garantía cubre una re-limpieza sin costo.",
      },
    ],
    waMessage:
      "¡Hola Colors Limpieza! Necesito cotizar la limpieza profunda de muebles/sofá. Ubicación: [Mi barrio o sector].",
  },
  {
    slug: "limpieza-colchones",
    name: "Limpieza de Colchones",
    shortName: "Colchones",
    tagline: "Duerme sobre un colchón desinfectado, libre de ácaros",
    description:
      "Pasamos un tercio de la vida en la cama. Nuestro servicio de limpieza y desinfección de colchones elimina ácaros, manchas, olores y bacterias con tecnología de inyección-succión, para que descanses en un colchón realmente limpio.",
    image:
      "https://images.unsplash.com/photo-1560185128-e173042f79dd?crop=entropy&cs=srgb&fm=jpg&q=85",
    galleryImage:
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?crop=entropy&cs=srgb&fm=jpg&q=85",
    includes: [
      "Desinfección profunda anti-ácaros por ambas caras",
      "Eliminación de manchas de sudor, orina y bebidas",
      "Neutralización de olores a humedad",
      "Tratamiento antibacteriano y antihongos",
      "Insumos hipoalergénicos y biodegradables",
      "Secado rápido: duermes en él el mismo día",
    ],
    benefits: [
      "Alivia síntomas de alergias y asma nocturna",
      "Mejora la calidad del sueño de toda la familia",
      "Ideal para bebés, niños y personas alérgicas",
    ],
    faqs: [
      {
        q: "¿Cada cuánto debo limpiar el colchón?",
        a: "Recomendamos una limpieza profesional cada 6 meses. Si hay alérgicos, bebés o mascotas en casa, cada 3 a 4 meses.",
      },
      {
        q: "¿Puedo dormir en el colchón el mismo día?",
        a: "Sí. Con nuestro sistema de extracción de alta potencia el colchón queda apenas húmedo y completamente seco en 4 a 6 horas.",
      },
      {
        q: "¿Eliminan manchas de orina y su olor?",
        a: "Sí, tratamos manchas de orina, vómito y otras con enzimas especializadas que eliminan la mancha y neutralizan el olor desde la raíz.",
      },
      {
        q: "¿Limpian colchones de cunas y camas nido?",
        a: "Sí, limpiamos todo tamaño: cuna, sencillo, doble, queen y king, además de colchonetas y bases de cama.",
      },
    ],
    waMessage:
      "¡Hola Colors Limpieza! Quiero cotizar la desinfección de colchones. Ubicación: [Mi barrio o sector].",
  },
  {
    slug: "limpieza-interior-vehiculos",
    name: "Limpieza de Interior de Vehículos",
    shortName: "Vehículos",
    tagline: "Tu carro oliendo a nuevo, sin salir de tu casa u oficina",
    description:
      "Lavamos y desinfectamos la tapicería completa de tu vehículo a domicilio en Medellín: sillas, alfombras, techo, puertas y baúl. Eliminamos manchas, pelos de mascota y olores difíciles con inyección-succión y secado rápido.",
    image:
      "https://images.unsplash.com/photo-1771491237218-cbd4a707497e?crop=entropy&cs=srgb&fm=jpg&q=85",
    galleryImage:
      "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&q=85",
    includes: [
      "Lavado de sillas por inyección-succión",
      "Limpieza de alfombras, piso y baúl",
      "Lavado de techo y tapizado de puertas",
      "Eliminación de pelos de mascota",
      "Neutralización de olores (comida, humedad, cigarrillo)",
      "Secado rápido: recuperas tu carro el mismo día",
    ],
    benefits: [
      "Un interior impecable aumenta el valor de venta del carro",
      "Servicio a domicilio: en tu casa, oficina o parqueadero",
      "Viaja más cómodo y saludable todos los días",
    ],
    faqs: [
      {
        q: "¿Van hasta donde está mi carro?",
        a: "Sí, el servicio es 100% a domicilio en Medellín y el Valle de Aburrá. Solo necesitamos acceso al vehículo y un punto de energía cercano.",
      },
      {
        q: "¿Cuánto tarda el servicio completo?",
        a: "Entre 2 y 3 horas según el tamaño y estado del vehículo. Las sillas quedan secas en 4 a 6 horas.",
      },
      {
        q: "¿Limpian cuero y cuero sintético?",
        a: "Sí, para cuero usamos limpieza y nutrición especializada que hidrata el material sin dañarlo ni dejarlo grasoso.",
      },
      {
        q: "¿Atienden flotas de empresas o taxis?",
        a: "Sí, tenemos planes especiales para flotas, taxis y plataformas de transporte con precios por volumen.",
      },
    ],
    waMessage:
      "¡Hola Colors Limpieza! Deseo cotizar la limpieza de tapicería de vehículo. Marca/Modelo: [Mi carro]. Ubicación: [Mi barrio o sector].",
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
